module.exports = __webpack_public_path__ + "img/29.23de1c90.jpg";